import React from 'react';
import { Link } from 'react-router-dom';

interface ILinkButton {
  text: string;
  icon: string;
  onClick?: () => void;
  href?: string;
  external?: boolean;
}

const LinkButton: React.FC<ILinkButton> = ({
  text,
  icon,
  onClick,
  href,
  external = false,
}) => {
  const content = (
    <>
      <div>
        <img src={icon} alt="" />
      </div>
      <div className="text-sm font-bold text-grey-700 underline cursor-pointer">
        {text}
      </div>
    </>
  );

  if (onClick) {
    return (
      <button onClick={onClick} className="flex items-center gap-2 pt-2">
        {content}
      </button>
    );
  }

  if (href) {
    if (external) {
      return (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 pt-2"
        >
          {content}
        </a>
      );
    }
    return (
      <Link to={href} target="_blank" className="flex items-center gap-2 pt-2">
        {content}
      </Link>
    );
  }

  return null;
};

export default LinkButton;
